/*
 * @Author: zhouyx
 * @Date: 2023-08-08 14:26:50
 * @LastEditTime: 2023-08-09 09:27:47
 * @LastEditors: zhouyx
 * @FilePath: \长春市民卡h5-s\src\main.js
 * @程序猿: 佛祖保佑     永不宕机     永无BUG
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import store from "./store";
import "./vant-ui";
import "vant/lib/index.css";
import App from "./App";
import "./utils/http-request";
import "./assets/js/rem";
import "./filters";
import VueWechatTitle from "vue-wechat-title";
import "./assets/font/iconfont.css";

// import 'amfe-flexible';
// px2rem 自适应
// import 'lib-flexible'
// import {router} from './router';
// import {Vconsole} from 'vconsole';
// import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper)
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);
import router from "./router";
import Vconsole from "vconsole";
Vue.use(VueWechatTitle);
Vue.config.productionTip = false;
//引入基本模板
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/line");
require("echarts/lib/chart/bar");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
Vue.prototype.$echarts = echarts;
if (process.env.NODE_ENV !== "production") {
  const vConsole = new Vconsole();
  Vue.use(vConsole);
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js